import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';

// app modules: components
import AlacarteOffer from 'components/AlacarteOffer';
import AppStoreLogos from 'components/AppStoreLogos';
import Heading from 'components/Heading';
import MembershipBenefits from 'components/MembershipBenefits';

// app modules: services
import { isApp } from 'services/environment';
import history from 'services/history';

// app: assets
import CssInlinePaywall from './InlinePaywall.scss';

function AlacartePaywallContent(props) {
  const { isbn } = props;
  useStyles(CssInlinePaywall);
  const loggedIn = useSelector(state => state.user.logged_in);

  const columns = [
    <div key="col1" className="inline-paywall__col inline-paywall__col--space-between">
      <div>
        <Heading id="paywall-heading" level={2} className="heading--size-32">
          {loggedIn ? (
            'About à la carte books'
          ) : (
            <span>
              Get <span className="hide-on-mobile">instant</span> online access via ckbk
            </span>
          )}
        </Heading>
        <MembershipBenefits
          type={loggedIn ? 'alacarte-member' : 'alacarte-nonmember'}
          itemClassName="margin-bottom-5"
          className="inline-paywall__benefits"
        />
      </div>
      {loggedIn ? null : (
        <div className="inline-paywall__wrapping-row">
          <p className="inline-paywall__login">
            Already a member?{' '}
            <button
              onClick={() => history.push('/login', { returnTo: history.location })}
              className="link link--energized"
            >
              Log in
            </button>
          </p>
          {isApp() ? null : <AppStoreLogos height={40} />}
        </div>
      )}
    </div>,
    <div key="col2" className="inline-paywall__col">
      <AlacarteOffer isbn={isbn} className="margin-bottom-20" />
    </div>,
  ];
  return (
    <div>
      <div className="inline-paywall__columns">{loggedIn ? columns.reverse() : columns}</div>
    </div>
  );
}

AlacartePaywallContent.propTypes = {
  isbn: PropTypes.string.isRequired,
};

AlacartePaywallContent.defaultProps = {};

export default React.memo(AlacartePaywallContent);
